import angular from 'angular'
import uiRouter from 'angular-ui-router'
import categorycard4Component from './categorycard4.component'

const categorycard4Module = angular.module('categorycard4', [
    uiRouter
])
    .config(($stateProvider) => {
        'ngInject'

        $stateProvider
            .state('categorycard4', {
                url: '/categorycard4',
                component: 'categorycard4'
            })
    })

    .component('categorycard4', categorycard4Component)

    .name

export default categorycard4Module



// WEBPACK FOOTER //
// ./client/app/components/home/book/step3/categorycard4/categorycard4.js